module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fb-Gd-Hc-Ia.6a49d412.png";